import {
  HttpContextToken,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ActionActivityService } from '@arm-web/ui-components';

/**
 * Set on a request that should not count as user-visible activity, such as
 * background polling: `{ context: new HttpContext().set(SILENT_REQUEST, true) }`.
 */
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);

/**
 * Reports every request to {@link ActionActivityService}.
 *
 * This is what makes action feedback global: the progress bar and the button
 * the user just clicked both read that service, so no screen has to raise or
 * lower a loading flag of its own.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const activity = inject(ActionActivityService);

  if (isSilent(req)) {
    return next(req);
  }

  const handle = activity.start();

  return next(req).pipe(finalize(() => activity.finish(handle)));
};

function isSilent(request: HttpRequest<unknown>): boolean {
  return request.context.get(SILENT_REQUEST);
}
